export default "__VITE_ASSET__BVl5LKZG__"